/**
 * Created by Ning Jiang on 5/15/2017.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Sine, Timeline, TimelineLite, TweenLite} from "gsap";
import {WixxGameConfig} from "../../WixxGameConfig";
import {Wixx} from "../../Wixx";

export class WixxInitialWPView extends BaseView {

    private _winNumberStyle:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : 45,
        fontWeight : "800",
        fill : "#ffffff"
        // dropShadow: true,
        // dropShadowColor: '#101010',
        // dropShadowAngle: Math.PI / 6,
        // dropShadowDistance: 5
    };

    private _winBurstsPool:TimelineSprite[] = [];
    private _winBursts:TimelineSprite[] = [];
    private _winNumbersPool:PIXI.Text[] = [];
    private _winNumbers:PIXI.Text[] = [];

    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WixxGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    public addWinBurstToTimeline(timeline:Timeline, startTime:number, symbolDuration:number, position:[number, number], isBoostedSymbol:boolean):void {
        const winBurst:TimelineSprite = this.getWinBurst();
        winBurst.position.set(position[0], position[1]);
        this._layer.addChild(winBurst);
        this._winBursts.push(winBurst);

        timeline.add([
            () => {
                winBurst.visible = true;
            },
            winBurst.getAnimation()
        ], startTime + (isBoostedSymbol ? 1 : 0));

        timeline.add(() => {
            winBurst.visible = false;
            this._layer.removeChild(winBurst);
            ArrayHelper.removeFirstMatchElement(this._winBursts, winBurst);
            this._winBurstsPool.push(winBurst);
        }, startTime + symbolDuration);
    }

    private getWinBurst():TimelineSprite {
        if(this._winBurstsPool.length === 0) {
            const winBurst:TimelineSprite = new TimelineSprite(GameResources.getTextures("winBurst"));
            winBurst.visible = false;
            winBurst.blendMode = PIXI.BLEND_MODES.SCREEN;
            winBurst.scale.set(1.5, 1.5);
            winBurst.anchor.set(0.5, 0.5);

            return winBurst;
        }

        return this._winBurstsPool.pop()!;
    }

    private getWinWaysText(ways:number){
        const winWays:PIXI.Text = new PIXI.Text(ways+" "+Wixx.api.translations.translate(ways>1?"Ways":"Way"),  {
            fontFamily : "Open Sans",
            fontSize : 30,
            fontWeight : "800",
            fill : "#ffffff"
        });
        winWays.visible = false;
        winWays.anchor.set(0.5, 0.5);
        return winWays;
    }

    public playWinNumber(betWayWinData:IBetWayWinData, startPosition:[number, number], offsetY:number, totalDuration:number, fadeOutDuration:number):void {
        const winNumber:PIXI.Text = this.getWinNumber();
        winNumber.text = this.getWinNumberText(betWayWinData);

        const winWays:PIXI.Text=this.getWinWaysText(betWayWinData.numberOfCombinations);

        this._winNumbers.push(winNumber);
        this._layer.addChild(winNumber,winWays);

        const timeline:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => {
                ArrayHelper.removeFirstMatchElement(this._winNumbers, winNumber);
                this._layer.removeChild(winNumber,winWays);
                winNumber.visible = false;
                this._winNumbersPool.push(winNumber);
            }
        });
        timeline.add(
            () => {
                winWays.visible=true;
                winNumber.visible = true;
                winNumber.alpha = 1;
            }
        );
        timeline.add(
            [TweenLite.fromTo(winWays.position, totalDuration,
                {x : startPosition[0], y : startPosition[1]+40},
                {x : startPosition[0], y : startPosition[1]+40 + offsetY, ease : Sine.easeOut}),
                TweenLite.fromTo(winNumber.position, totalDuration,
                    {x : startPosition[0], y : startPosition[1]},
                    {x : startPosition[0], y : startPosition[1] + offsetY, ease : Sine.easeOut})]
        );
        timeline.add(
            TweenLite.to([winNumber,winWays], fadeOutDuration, {alpha : 0}),
            totalDuration - fadeOutDuration
        );

        timeline.play();
    }

    private getWinNumberText(betWayWinData:IBetWayWinData):string {
        let str:string = Currency.formatValue(betWayWinData.amount);
        if(betWayWinData.multiplier > 1) {
            str += ` X ${betWayWinData.multiplier}`;
        }

        return str;
    }

    private getWinNumber():PIXI.Text {
        if(this._winNumbersPool.length === 0) {
            const winNumber:PIXI.Text = new PIXI.Text("0", this._winNumberStyle);
            winNumber.visible = false;
            winNumber.anchor.set(0.5, 0.5);

            return winNumber;
        }

        return this._winNumbersPool.pop()!;
    }

    public stopWinPresentation():void {
        while(this._winBursts.length > 0) {
            const winBurst:TimelineSprite = this._winBursts.pop()!;
            this._layer.removeChild(winBurst);
            winBurst.visible = false;
            this._winBurstsPool.push(winBurst);
        }
    }
}